<template>
  <div>
    <label v-if="label">{{ label }}</label>
    <input
      v-mask="currencyMask"
      :disabled="disabled"
      :value="value"
      class="form-control"
      type="text"
      placeholder=""
      @input="updateValue"
    />
  </div>
</template>

<script>
  import createNumberMask from 'text-mask-addons/dist/createNumberMask';

  export default {
    name: 'SimpleCurrencyInput',
    props: {
      value: {
        type: [String, Number],
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      options: {
        type: Object,
        default: () => ({
          prefix: '$',
          allowDecimal: true,
          includeThousandsSeparator: true,
          allowNegative: false,
        }),
      },
      disabled: Boolean,
    },
    computed: {
      currencyMask() {
        return createNumberMask(this.options);
      },
    },
    methods: {
      cleanCurrencyString(currencyString) {
        if (!currencyString) return null;
        let amount = String(currencyString).replace(/[^\d.]/g, '');
        return parseFloat(amount);
      },
      updateValue(event) {
        this.$emit('input', this.cleanCurrencyString(event.target.value));
      },
    },
  };
</script>
